module.exports = __webpack_public_path__ + "img/icon-core3-3.f776f234.png";